import request from "@/utils/request";

// 单位列表
export function detailPro(query) {
  return request({
    url: "/v1.0/iwrs/project/detail",
    method: "get",
    params: query
  });
}
// 单位修改
export function updatePro(data) {
  return request({
    url: "/v1.0/iwrs/project/update",
    method: "put",
    data: data
  });
}

// 启动项目
export function start(data) {
  return request({
    url: "/v1.0/iwrs/project/start",
    method: "post",
    data
  });
}

// 首页图标数据接口
export function statistics(query) {
  return request({
    url: "/v1.0/iwrs/project/statistics",
    method: "get",
    params: query
  });
}

// 锁定项目
export function lockingPro(data) {
  return request({
    url: "/v1.0/iwrs/project/locking",
    method: "post",
    data
  });
}

//解锁项目
export function unLockingPro(data) {
  return request({
    url: "/v1.0/iwrs/project/unlocking",
    method: "post",
    data
  });
}

// 操作轨迹
export function operationList(query) {
  return request({
    url: "/v1.0/iwrs/operation_track/all",
    method: "get",
    params: query
  });
}

// 操作轨迹导出
export function exportFile(query) {
  return request({
    url: "/v1.0/iwrs/operation_track/export",
    method: "get",
    params: query
  });
}
